import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/button';
import { Col, Row } from 'components/grid';
import DndProvider from 'components/dnd/DndProvider';
import DraggableWrapper from 'components/dnd/DraggableWrapper';

const ItemContainer = styled(Row)`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.backgroundColorWhite};
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
  margin-bottom: 4px;
  align-items: center;
  padding-left: 16px;
  ${({ theme }) => theme.typograph.paragraphRegular}
`;

const ColButton = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const DraggableList = ({
  Header, items, onSelect, Content, selectLabel, className,
  id, onDragEnd,
}) => (
  <div className={className}>
    {Header && <Header />}
    <DndProvider id={id} onDragEnd={onDragEnd}>
      {items.map((item, index) => (
        <DraggableWrapper key={item.field} id={item.field} index={index}>

          <ItemContainer>
            <Content item={item} />
            <ColButton col={2}>
              <Button variant="link" onClick={() => onSelect(item)}>{selectLabel}</Button>
            </ColButton>
          </ItemContainer>

        </DraggableWrapper>
      ))}
    </DndProvider>
  </div>
);

DraggableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onSelect: PropTypes.func.isRequired,
  Content: PropTypes.func.isRequired,
  Header: PropTypes.func,
  selectLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onDragEnd: PropTypes.func.isRequired,
};

DraggableList.defaultProps = {
  className: null,
  Header: null,
};

export default DraggableList;
